// import headerImage from '../images/BF_Header_Home_Zuschnitt.png';
import {Customization} from '@eduvision/toolkit';
import {default as CustomLoggedOutView} from '../views/LoggedOutView';

export const LoggedOutView: Customization['LoggedOutView'] = {
  component: CustomLoggedOutView
  // headerImageSrc: headerImage
};